module.exports = __webpack_public_path__ + "static/media/tmc-story-page-1-thumbnail.7b326826.png";